import React from 'react'
import Navbar from '../../components/navbar/Navbar'
import IncentiveReport from '../../components/reports/IncentiveReport'

const IncentivePage = () => {
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    {/* Navbar */}
                    <div className="row">
                        <div className="col-12 p-0">
                            <Navbar content="INCENTIVE REPORT" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 p-0">
                            <IncentiveReport />
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default IncentivePage